import { render, staticRenderFns } from "./FavoritesDialog.vue?vue&type=template&id=079360b0"
import script from "./FavoritesDialog.vue?vue&type=script&lang=js"
export * from "./FavoritesDialog.vue?vue&type=script&lang=js"
import style0 from "./FavoritesDialog.vue?vue&type=style&index=0&id=079360b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports